// extracted by mini-css-extract-plugin
export var accordion = "_bh-0";
export var chevron = "_bh-3";
export var closed = "_bh-2";
export var content = "_bh-4";
export var open = "_bh-1";
export var rotate = "_bh-5";